/**
 * @file 定义路由匹配，渲染对应的 UI 组件
 * @author chris<wfsr@foxmail.com>
 */

import {Switch} from 'react-router-dom';

import EnhancedRoute from './component/EnhancedRoute';
import routes from './route.config';

import BasicLayout from './layout/BasicLayout';
import BlankLayout from './layout/BlankLayout';
import QRLoginLayout from './layout/QRLoginLayout';


import {joinPath} from './utils/url';

const layouts = {
    BasicLayout,
    BlankLayout,
    QRLoginLayout,
};

/**
 * 将路由配置格式化：每个路由中的routes对象下的路由打平
 *
 * @param {Array} routes 路由配置数组
 * @param {Object=} superRoute 上级路由对象
 * @return {Array}
 */
const formatRoutes = (routes, superRoute) => {
    const {path = ''} = superRoute || {};

    return routes.reduce((newRoutes, route) => {
        const {routes: children, ...rest} = route;

        const {path: subPath = ''} = rest;
        rest.path = joinPath(path, subPath);
        if (superRoute) {
            rest.super = superRoute;
        }

        newRoutes.push(rest);

        if (children?.length) {
            newRoutes.push(...formatRoutes(children, rest));
        }

        return newRoutes;
    }, []);
};

export default function Routes() {
    return (
        <Switch>
            {formatRoutes(routes).map(
                route => {
                    const {
                        path = '/',
                        layout = 'BasicLayout',
                        exact = true,
                        redirect = ''
                    } = route;

                    return (
                        <EnhancedRoute
                            exact={exact}
                            key={path}
                            path={path}
                            redirect={redirect}
                            layout={layouts[layout]}
                            routeConfig={route}
                        />
                    );
                }
            )}
        </Switch>
    );
}
